<template>
  <div class="ui tab segment" data-tab="menu">
    <div class="ui top secondary menu">
      <a class="item" data-tab="menu/course">宴会コース</a>
      <a class="item" data-tab="menu/drink">飲み放題</a>
      <a class="item" data-tab="menu/catering">ケータリング</a>
      <a class="item" data-tab="menu/meeting">会議室プラン</a>
      <a class="item" data-tab="menu/lodge-meeting">宿泊会議プラン</a>
    </div>

    <bulk-copy-modal ref="bulkCopyModal"></bulk-copy-modal>

    <div class="ui inner tab" data-tab="menu/course">
      <div v-if="canBulkCopy" class="right aligned">
        <button class="ui small olive button" @click="openCoursesBulkCopyDialog">現在所属するグループに反映</button>
      </div>

      <div v-if="!reorderMode">
        <button class="ui mini default button" @click="reorderMode = true">並び順を変更する</button>
      </div>
      <div v-else>
        <button class="ui mini positive button" @click="reorderCourse">並び順を保存する</button>
        <a class="clickable" @click="reload">キャンセル</a>
      </div>
      <table class="ui celled striped table">
        <tbody>
          <tr v-for="(form, i) in courseForms" :key="i">
            <td v-if="reorderMode" style="width: 30px">
              <i @click="moveUp(courseForms, i)" class="clickable arrow up icon"></i>
              <i @click="moveDown(courseForms, i)" class="clickable arrow down icon"></i>
            </td>
            <td>
              <form class="ui form" :class="{'warning': form.hasErrors()}">
                <div class="fields">
                  <div class="required eight wide field">
                    <label>公開状態</label>
                    <div class="ui checkbox radio">
                      <input v-model="form.model.is_published" type="radio" name="is_published" value="true">
                      <label>公開</label>
                    </div>
                    <div class="ui checkbox radio">
                      <input v-model="form.model.is_published" type="radio" name="is_published" value="false">
                      <label>非公開</label>
                    </div>
                  </div>
                </div>
                <div class="fields">
                  <div class="required seven wide field">
                    <label>プラン名</label>
                    <input type="text" v-model="form.model.name">
                    <validation-message :form="form" :field="'name'"></validation-message>
                  </div>
                  <div class="required three wide field">
                    <label>通常価格</label>
                    <div class="ui right labeled input">
                      <input type="number" v-model="form.model.price">
                      <label class="ui label">円</label>
                    </div>
                    <validation-message :form="form" :field="'price'"></validation-message>
                  </div>
                  <div class="three wide field">
                    <label>割引後価格</label>
                    <div class="ui right labeled input">
                      <input type="number" v-model="form.model.discounted_price">
                      <label class="ui label">円</label>
                    </div>
                    <validation-message :form="form" :field="'discounted_price'"></validation-message>
                  </div>
                  <div class="one wide field">
                    <label>税込</label>
                    <div class="ui checkbox">
                      <input v-model="form.model.tax_included" type="checkbox" name="drink_type">
                    </div>
                    <validation-message :form="form" :field="'tax_included'"></validation-message>
                  </div>
                  <div class="two wide field">
                    <label>品数</label>
                    <div class="ui right labeled input">
                      <input type="number" v-model="form.model.dish_count">
                      <label class="ui label">品</label>
                    </div>
                    <validation-message :form="form" :field="'dish_count'"></validation-message>
                  </div>
                </div>
                <div class="fields">
                  <div class="required five wide field">
                    <label>概要</label>
                    <textarea v-model="form.model.title" rows="5"></textarea>
                    <validation-message :form="form" :field="'title'"></validation-message>
                  </div>
                  <div class="required six wide field">
                    <label>内容</label>
                    <textarea v-model="form.model.contents" rows="5"></textarea>
                    <validation-message :form="form" :field="'contents'"></validation-message>
                  </div>
                  <div class="five wide field">
                    <label>備考</label>
                    <textarea v-model="form.model.description" rows="5"></textarea>
                    <validation-message :form="form" :field="'description'"></validation-message>
                  </div>
                </div>
                <div class="fields">
                  <div class="ten wide field">
                    <label>飲み放題</label>
                    <div class="fields">
                      <div v-for="drinkType in consts.SHOP_DRINK_TYPE" :key="drinkType.value" class="field">
                        <div class="ui checkbox radio">
                          <input v-model="form.model.drink_type" type="radio" name="drink_type" :value="drinkType.value">
                          <label>{{ drinkType.label }}</label>
                        </div>
                      </div>
                    </div>
                    <validation-message :form="form" :field="'drink_type'"></validation-message>
                  </div>
                  <div class="six wide field">
                    <label>イメージ画像</label>
                    <s3 v-model="form.model.image"></s3>
                    <validation-message :form="form" :field="'image'"></validation-message>
                  </div>
                </div>
                <div class="fields">
                  <div class="four wide field">
                    <label>特典・PR</label>
                    <div class="ui checkbox radio">
                      <input v-model="form.model.has_benefit" type="radio" name="has_benefit" value="true">
                      <label>特典あり</label>
                    </div>
                    <div class="ui checkbox radio">
                      <input v-model="form.model.has_benefit" type="radio" name="has_benefit" value="false">
                      <label>特典なし</label>
                    </div>
                  </div>
                  <div class="twelve wide field">
                    <label>特典・PR詳細</label>
                    <textarea v-model="form.model.benefit_detail" rows="2"></textarea>
                  </div>
                </div>
                <div class="fields">
                  <div class="four wide field">
                    <label>プランの表示期間</label>
                    <div class="ui checkbox radio">
                      <input v-model="form.model.is_all_year" type="radio" name="is_all_year" value="true">
                      <label>通年</label>
                    </div>
                    <div class="ui checkbox radio">
                      <input v-model="form.model.is_all_year" type="radio" name="is_all_year" value="false">
                      <label>期間設定</label>
                    </div>
                  </div>
                  <div class="twelve wide field">
                    <label>プランの表示期間</label>
                    <div class="fields">
                      <div class="four wide field" :class="{'required': isReceptionPeriodSetting(form), 'reception-date-missing': receptionStartDateInvalid(form)}">
                        <datepick v-model="form.model.reception_start_date" placeholder="開始日"></datepick>
                        <validation-message :form="form" :field="'reception_start_date'"></validation-message>
                      </div>
                      <div class="four wide field" :class="{'required': isReceptionPeriodSetting(form), 'reception-date-missing': receptionEndDateInvalid(form)}">
                        <datepick v-model="form.model.reception_end_date" from="0" placeholder="終了日"></datepick>
                        <validation-message :form="form" :field="'reception_end_date'"></validation-message>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </td>
            <td class="actions">
              <button type="button" class="ui tiny positive button" :disabled="hasReceptionPeriodDetailError(form)" @click="saveCourse(form)">保存</button>
              <button type="button" class="ui tiny red button" @click="deleteCourse(form, i)">削除</button>
            </td>
          </tr>
        </tbody>
        <tfoot class="full-width">
          <th colspan="2">
            <div class="ui center aligned">
              <i class="clickable plus green large icon" @click="newCourse()"></i>
            </div>
          </th>
        </tfoot>
      </table>
    </div>

    <div class="ui inner tab" data-tab="menu/drink">
      <div v-if="canBulkCopy" class="right aligned">
        <button class="ui small olive button" @click="openDrinkMenusBulkCopyDialog">現在所属するグループに反映</button>
      </div>
      <div v-if="!reorderMode">
        <button class="ui mini default button" @click="reorderMode = true">並び順を変更する</button>
      </div>
      <div v-else>
        <button class="ui mini positive button" @click="reorderDrinkMenu">並び順を保存する</button>
        <a class="clickable" @click="reload">キャンセル</a>
      </div>
      <table class="ui celled table">
        <tbody>
          <tr v-for="(form, i) in drinkForms" :key="i">
            <td v-if="reorderMode" style="width: 30px">
              <i @click="moveUp(drinkForms, i)" class="clickable arrow up icon"></i>
              <i @click="moveDown(drinkForms, i)" class="clickable arrow down icon"></i>
            </td>
            <td>
              <form class="ui form" :class="{'warning': form.hasErrors()}">
                <div class="fields">
                  <div class="required eight wide field">
                    <label>タイトル</label>
                    <input type="text" v-model="form.model.name">
                    <validation-message :form="form" :field="'name'"></validation-message>
                  </div>
                  <div class="eight wide field">
                    <label>メニュー詳細</label>
                    <textarea v-model="form.model.contents" rows="2"></textarea>
                    <validation-message :form="form" :field="'contents'"></validation-message>
                  </div>
                </div>
              </form>
            </td>
            <td class="actions">
              <button type="button" class="ui tiny positive button" @click="saveDrinkMenu(form)">保存</button>
              <button type="button" class="ui tiny red button" @click="deleteDrinkMenu(form, i)">削除</button>
            </td>
          </tr>
        </tbody>
        <tfoot class="full-width">
          <th colspan="2">
            <div class="ui center aligned">
              <i class="clickable plus green large icon" @click="newDrink()"></i>
            </div>
          </th>
        </tfoot>
      </table>
    </div>

    <div class="ui inner tab" data-tab="menu/catering">
      <div v-if="!reorderMode">
        <button class="ui mini default button" @click="reorderMode = true">並び順を変更する</button>
      </div>
      <div v-else>
        <button class="ui mini positive button" @click="reorderCatering">並び順を保存する</button>
        <a class="clickable" @click="reload">キャンセル</a>
      </div>
      <table class="ui celled striped table">
        <tbody>
          <tr v-for="(form, i) in cateringForms" :key="i">
            <td v-if="reorderMode" style="width: 30px">
              <i @click="moveUp(cateringForms, i)" class="clickable arrow up icon"></i>
              <i @click="moveDown(cateringForms, i)" class="clickable arrow down icon"></i>
            </td>
            <td>
              <form class="ui form" :class="{'warning': form.hasErrors()}">
              <div class="fields">
                <div class="required seven wide field">
                  <label>コース名</label>
                  <input type="text" v-model="form.model.name">
                  <validation-message :form="form" :field="'name'"></validation-message>
                </div>
                <div class="required three wide field">
                  <label>通常価格</label>
                  <div class="ui right labeled input">
                    <input type="number" v-model="form.model.price">
                    <label class="ui label">円</label>
                  </div>
                  <validation-message :form="form" :field="'price'"></validation-message>
                </div>
                <div class="three wide field">
                  <label>割引後価格</label>
                  <div class="ui right labeled input">
                    <input type="number" v-model="form.model.discounted_price">
                    <label class="ui label">円</label>
                  </div>
                  <validation-message :form="form" :field="'discounted_price'"></validation-message>
                </div>
                <div class="one wide field">
                  <label>税込</label>
                  <div class="ui checkbox">
                    <input v-model="form.model.tax_included" type="checkbox" name="drink_type">
                  </div>
                  <validation-message :form="form" :field="'tax_included'"></validation-message>
                </div>
                <div class="two wide field">
                  <label>品数</label>
                  <div class="ui right labeled input">
                    <input type="number" v-model="form.model.dish_count">
                    <label class="ui label">品</label>
                  </div>
                  <validation-message :form="form" :field="'dish_count'"></validation-message>
                </div>
              </div>
              <div class="fields">
                <div class="required five wide field">
                  <label>概要</label>
                  <textarea v-model="form.model.title" rows="5"></textarea>
                  <validation-message :form="form" :field="'title'"></validation-message>
                </div>
                <div class="required six wide field">
                  <label>内容</label>
                  <textarea v-model="form.model.contents" rows="5"></textarea>
                  <validation-message :form="form" :field="'contents'"></validation-message>
                </div>
                <div class="five wide field">
                  <label>備考</label>
                  <textarea v-model="form.model.description" rows="5"></textarea>
                  <validation-message :form="form" :field="'description'"></validation-message>
                </div>
              </div>
              <div class="field">
                <label>イメージ画像</label>
                <s3 v-model="form.model.image"></s3>
                <validation-message :form="form" :field="'image'"></validation-message>
              </div>
              </form>
            </td>
            <td class="actions">
              <button type="button" class="ui tiny positive button" @click="saveCatering(form)">保存</button>
              <button type="button" class="ui tiny red button" @click="deleteCatering(form, i)">削除</button>
            </td>
          </tr>
        </tbody>
        <tfoot class="full-width">
          <th colspan="2">
            <div class="ui center aligned">
              <i class="clickable plus green large icon" @click="newCatering()"></i>
            </div>
          </th>
        </tfoot>
      </table>
    </div>

    <div class="ui inner tab" data-tab="menu/meeting">
      <div v-if="canBulkCopy" class="right aligned">
        <button class="ui small olive button" @click="openMeetingsBulkCopyDialog">現在所属するグループに反映</button>
      </div>

      <div v-if="!reorderMode">
        <button class="ui mini default button" @click="reorderMode = true">並び順を変更する</button>
      </div>
      <div v-else>
        <button class="ui mini positive button" @click="reorderMeeting">並び順を保存する</button>
        <a class="clickable" @click="reload">キャンセル</a>
      </div>
      <table class="ui celled striped table">
        <tbody>
          <tr v-for="(form, i) in meetingForms" :key="i">
            <td v-if="reorderMode" style="width: 30px">
              <i @click="moveUp(meetingForms, i)" class="clickable arrow up icon"></i>
              <i @click="moveDown(meetingForms, i)" class="clickable arrow down icon"></i>
            </td>
            <td>
              <form class="ui form" :class="{'warning': form.hasErrors()}">
              <div class="fields">
                <div class="required eight wide field">
                  <label>公開状態</label>
                  <div class="ui checkbox radio">
                    <input v-model="form.model.is_published" type="radio" name="meeting_is_published" value="true">
                    <label>公開</label>
                  </div>
                  <div class="ui checkbox radio">
                    <input v-model="form.model.is_published" type="radio" name="meeting_is_published" value="false">
                    <label>非公開</label>
                  </div>
                </div>
              </div>
              <div class="fields">
                <div class="required seven wide field">
                  <label>プラン名</label>
                  <input type="text" v-model="form.model.name">
                  <validation-message :form="form" :field="'name'"></validation-message>
                </div>
                <div class="required three wide field">
                  <label>通常価格</label>
                  <div class="ui right labeled input">
                    <input type="number" v-model="form.model.price">
                    <label class="ui label">円</label>
                  </div>
                  <validation-message :form="form" :field="'price'"></validation-message>
                </div>
                <div class="three wide field">
                  <label>割引後価格</label>
                  <div class="ui right labeled input">
                    <input type="number" v-model="form.model.discounted_price">
                    <label class="ui label">円</label>
                  </div>
                  <validation-message :form="form" :field="'discounted_price'"></validation-message>
                </div>
                <div class="one wide field">
                  <label>税込</label>
                  <div class="ui checkbox">
                    <input v-model="form.model.tax_included" type="checkbox" name="drink_type">
                  </div>
                  <validation-message :form="form" :field="'tax_included'"></validation-message>
                </div>
                <div class="two wide field"></div>
              </div>
              <div class="fields">
                <div class="required five wide field">
                  <label>概要</label>
                  <textarea v-model="form.model.title" rows="5"></textarea>
                  <validation-message :form="form" :field="'title'"></validation-message>
                </div>
                <div class="required six wide field">
                  <label>内容</label>
                  <textarea v-model="form.model.contents" rows="5"></textarea>
                  <validation-message :form="form" :field="'contents'"></validation-message>
                </div>
                <div class="five wide field">
                  <label>備考</label>
                  <textarea v-model="form.model.description" rows="5"></textarea>
                  <validation-message :form="form" :field="'description'"></validation-message>
                </div>
              </div>
              <div class="fields">
                <div class="six wide field">
                  <label>イメージ画像</label>
                  <s3 v-model="form.model.image"></s3>
                  <validation-message :form="form" :field="'image'"></validation-message>
                </div>
              </div>
              <div class="fields">
                <div class="four wide field">
                  <label>特典・PR</label>
                  <div class="ui checkbox radio">
                    <input v-model="form.model.has_benefit" type="radio" name="meeting_has_benefit" value="true">
                    <label>特典あり</label>
                  </div>
                  <div class="ui checkbox radio">
                    <input v-model="form.model.has_benefit" type="radio" name="meeting_has_benefit" value="false">
                    <label>特典なし</label>
                  </div>
                </div>
                <div class="twelve wide field">
                  <label>特典・PR詳細</label>
                  <textarea v-model="form.model.benefit_detail" rows="2"></textarea>
                </div>
              </div>
              <div class="fields">
                <div class="four wide field">
                  <label>プランの表示期間</label>
                  <div class="ui checkbox radio">
                    <input v-model="form.model.is_all_year" type="radio" name="meeting_is_all_year" value="true">
                    <label>通年</label>
                  </div>
                  <div class="ui checkbox radio">
                    <input v-model="form.model.is_all_year" type="radio" name="meeting_is_all_year" value="false">
                    <label>期間設定</label>
                  </div>
                </div>
                <div class="twelve wide field">
                  <label>プランの表示期間</label>
                  <div class="fields">
                    <div class="four wide field" :class="{'required': isReceptionPeriodSetting(form), 'reception-date-missing': receptionStartDateInvalid(form)}">
                      <datepick v-model="form.model.reception_start_date" placeholder="開始日"></datepick>
                      <validation-message :form="form" :field="'reception_start_date'"></validation-message>
                    </div>
                    <div class="four wide field" :class="{'required': isReceptionPeriodSetting(form), 'reception-date-missing': receptionEndDateInvalid(form)}">
                      <datepick v-model="form.model.reception_end_date" :from="0" placeholder="終了日"></datepick>
                      <validation-message :form="form" :field="'reception_end_date'"></validation-message>
                    </div>
                  </div>
                </div>
              </div>
              </form>
            </td>
            <td class="actions">
              <button type="button" class="ui tiny positive button" :disabled="hasReceptionPeriodDetailError(form)" @click="saveMeeting(form)">保存</button>
              <button type="button" class="ui tiny red button" @click="deleteMeeting(form, i)">削除</button>
            </td>
          </tr>
        </tbody>
        <tfoot class="full-width">
          <th colspan="2">
            <div class="ui center aligned">
              <i class="clickable plus green large icon" @click="newMeeting()"></i>
            </div>
          </th>
        </tfoot>
      </table>
    </div>

    <div class="ui inner tab" data-tab="menu/lodge-meeting">
      <div v-if="canBulkCopy" class="right aligned">
        <button class="ui small olive button" @click="openLodgeMeetingsBulkCopyDialog">現在所属するグループに反映</button>
      </div>

      <div v-if="!reorderMode">
        <button class="ui mini default button" @click="reorderMode = true">並び順を変更する</button>
      </div>
      <div v-else>
        <button class="ui mini positive button" @click="reorderLodgeMeeting">並び順を保存する</button>
        <a class="clickable" @click="reload">キャンセル</a>
      </div>
      <table class="ui celled striped table">
        <tbody>
          <tr v-for="(form, i) in lodgeMeetingForms" :key="i">
            <td v-if="reorderMode" style="width: 30px">
              <i @click="moveUp(lodgeMeetingForms, i)" class="clickable arrow up icon"></i>
              <i @click="moveDown(lodgeMeetingForms, i)" class="clickable arrow down icon"></i>
            </td>
            <td>
              <form class="ui form" :class="{'warning': form.hasErrors()}">
              <div class="fields">
                <div class="required eight wide field">
                  <label>公開状態</label>
                  <div class="ui checkbox radio">
                    <input v-model="form.model.is_published" type="radio" name="lodge_meeting_is_published" value="true">
                    <label>公開</label>
                  </div>
                  <div class="ui checkbox radio">
                    <input v-model="form.model.is_published" type="radio" name="lodge_meeting_is_published" value="false">
                    <label>非公開</label>
                  </div>
                </div>
              </div>
              <div class="fields">
                <div class="required seven wide field">
                  <label>プラン名</label>
                  <input type="text" v-model="form.model.name">
                  <validation-message :form="form" :field="'name'"></validation-message>
                </div>
                <div class="required three wide field">
                  <label>通常価格</label>
                  <div class="ui right labeled input">
                    <input type="number" v-model="form.model.price">
                    <label class="ui label">円</label>
                  </div>
                  <validation-message :form="form" :field="'price'"></validation-message>
                </div>
                <div class="three wide field">
                  <label>割引後価格</label>
                  <div class="ui right labeled input">
                    <input type="number" v-model="form.model.discounted_price">
                    <label class="ui label">円</label>
                  </div>
                  <validation-message :form="form" :field="'discounted_price'"></validation-message>
                </div>
                <div class="one wide field">
                  <label>税込</label>
                  <div class="ui checkbox">
                    <input v-model="form.model.tax_included" type="checkbox" name="drink_type">
                  </div>
                  <validation-message :form="form" :field="'tax_included'"></validation-message>
                </div>
                <div class="two wide field"></div>
              </div>
              <div class="fields">
                <div class="required five wide field">
                  <label>概要</label>
                  <textarea v-model="form.model.title" rows="5"></textarea>
                  <validation-message :form="form" :field="'title'"></validation-message>
                </div>
                <div class="required six wide field">
                  <label>内容</label>
                  <textarea v-model="form.model.contents" rows="5"></textarea>
                  <validation-message :form="form" :field="'contents'"></validation-message>
                </div>
                <div class="five wide field">
                  <label>備考</label>
                  <textarea v-model="form.model.description" rows="5"></textarea>
                  <validation-message :form="form" :field="'description'"></validation-message>
                </div>
              </div>
              <div class="fields">
                <div class="six wide field">
                  <label>イメージ画像</label>
                  <s3 v-model="form.model.image"></s3>
                  <validation-message :form="form" :field="'image'"></validation-message>
                </div>
              </div>
              <div class="fields">
                <div class="four wide field">
                  <label>特典・PR</label>
                  <div class="ui checkbox radio">
                    <input v-model="form.model.has_benefit" type="radio" name="lodge_meeting_has_benefit" value="true">
                    <label>特典あり</label>
                  </div>
                  <div class="ui checkbox radio">
                    <input v-model="form.model.has_benefit" type="radio" name="lodge_meeting_has_benefit" value="false">
                    <label>特典なし</label>
                  </div>
                </div>
                <div class="twelve wide field">
                  <label>特典・PR詳細</label>
                  <textarea v-model="form.model.benefit_detail" rows="2"></textarea>
                </div>
              </div>
              <div class="fields">
                <div class="four wide field">
                  <label>プランの表示期間</label>
                  <div class="ui checkbox radio">
                    <input v-model="form.model.is_all_year" type="radio" name="lodge_meeting_is_all_year" value="true">
                    <label>通年</label>
                  </div>
                  <div class="ui checkbox radio">
                    <input v-model="form.model.is_all_year" type="radio" name="lodge_meeting_is_all_year" value="false">
                    <label>期間設定</label>
                  </div>
                </div>
                <div class="twelve wide field">
                  <label>プランの表示期間</label>
                  <div class="fields">
                    <div class="required four wide field">
                      <datepick v-model="form.model.reception_start_date" placeholder="開始日"></datepick>
                      <validation-message :form="form" :field="'reception_start_date'"></validation-message>
                    </div>
                    <div class="required four wide field">
                      <datepick v-model="form.model.reception_end_date" :from="0" placeholder="終了日"></datepick>
                      <validation-message :form="form" :field="'reception_end_date'"></validation-message>
                    </div>
                  </div>
                </div>
              </div>
              </form>
            </td>
            <td class="actions">
              <button type="button" class="ui tiny positive button" @click="saveLodgeMeeting(form)">保存</button>
              <button type="button" class="ui tiny red button" @click="deleteLodgeMeeting(form, i)">削除</button>
            </td>
          </tr>
        </tbody>
        <tfoot class="full-width">
          <th colspan="2">
            <div class="ui center aligned">
              <i class="clickable plus green large icon" @click="newLodgeMeeting()"></i>
            </div>
          </th>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import bulkCopyModal from './bulkCopyModal.vue';

export default {
    components: {
        bulkCopyModal: bulkCopyModal
    },
    data: function() {
        return {
            model: {},
            bulkCopyForm: this.createForm(),
            groupShops: [],
            groupShopNameFilter: null,
            courseForms: [],
            drinkForms: [],
            cateringForms: [],
            meetingForms: [],
            lodgeMeetingForms: [],
            reorderMode: false,
        };
    },
    computed: {
        canBulkCopy: function() {
            return this.model.group && this.userRole === 'afadmin';
        }
    },
    methods: {
        initialize: function(model) {
            this.model = model;
            _.forEach(this.model.courses, function(each) {
                this.courseForms.push(this.createForm(each));
                this.$nextTick(function() {
                    $('.ui.checkbox', this.$el).checkbox();
                });
            }.bind(this));
            _.forEach(this.model.drink_menus, function(each) {
                this.drinkForms.push(this.createForm(each));
            }.bind(this));
            _.forEach(this.model.caterings, function(each) {
                this.cateringForms.push(this.createForm(each));
                this.$nextTick(function() {
                    $('.ui.checkbox', this.$el).checkbox();
                });
            }.bind(this));
            _.forEach(this.model.meetings, function(each) {
                this.meetingForms.push(this.createForm(each));
                this.$nextTick(function() {
                    $('.ui.checkbox', this.$el).checkbox();
                });
            }.bind(this));
            _.forEach(this.model.lodge_meetings, function(each) {
                this.lodgeMeetingForms.push(this.createForm(each));
                this.$nextTick(function() {
                    $('.ui.checkbox', this.$el).checkbox();
                });
            }.bind(this));
            this.canBulkCopy && this.createForm().get('/afadmin/api/groups/' + this.model.group, function(response) {
                this.groupShops = _.filter(response.data.shops, function(each) {
                    return each.id !== this.model.id;
                }.bind(this));
            });
        },
        newCourse: function() {
            this.courseForms.push(this.createForm({
                drink_type: 1
            }));
            this.$nextTick(function() {
                $('.ui.checkbox', this.$el).checkbox();
            });
        },
        saveCourse: function(form) {
            if (this.hasReceptionPeriodDetailError(form)) {
                return;
            }
            if (form.model.id) {
                form.put(form.model.edit_api_url, function(response) {
                    this.merge(form.model, response.data);
                    alert('保存しました');
                });
            } else {
                form.post(this.model.new_course_api_url, function(response) {
                    this.merge(form.model, response.data);
                    alert('保存しました');
                });
            }
        },
        deleteCourse: function(form, i) {
            if (!form.model.id) {
                this.courseForms.splice(i, 1);
                return;
            }
            if (!confirm('削除します。よろしいですか？')) {
                return;
            }
            form.delete(form.model.edit_api_url, function() {
                this.courseForms.splice(i, 1);
            }.bind(this));
        },
        newDrink: function() {
            this.drinkForms.push(this.createForm());
        },
        saveDrinkMenu: function(form) {
            if (form.model.id) {
                form.put(form.model.edit_api_url, function(response) {
                    this.merge(form.model, response.data);
                    alert('保存しました');
                });
            } else {
                form.post(this.model.new_drink_menu_api_url, function(response) {
                    this.merge(form.model, response.data);
                    alert('保存しました');
                });
            }
        },
        deleteDrinkMenu: function(form, i) {
            if (!form.model.id) {
                this.drinkForms.splice(i, 1);
                return;
            }
            if (!confirm('削除します。よろしいですか？')) {
                return;
            }
            form.delete(form.model.edit_api_url, function() {
                this.drinkForms.splice(i, 1);
            }.bind(this));
        },
        newCatering: function() {
            this.cateringForms.push(this.createForm());
            this.$nextTick(function() {
                $('.ui.checkbox', this.$el).checkbox();
            });
        },
        saveCatering: function(form) {
            if (form.model.id) {
                form.put(form.model.edit_api_url, function(response) {
                    this.merge(form.model, response.data);
                    alert('保存しました');
                });
            } else {
                form.post(this.model.new_catering_api_url, function(response) {
                    this.merge(form.model, response.data);
                    alert('保存しました');
                });
            }
        },
        deleteCatering: function(form, i) {
            if (!form.model.id) {
                this.cateringForms.splice(i, 1);
                return;
            }
            if (!confirm('削除します。よろしいですか？')) {
                return;
            }
            form.delete(form.model.edit_api_url, function() {
                this.cateringForms.splice(i, 1);
            }.bind(this));
        },
        newMeeting: function() {
            this.meetingForms.push(this.createForm());
            this.$nextTick(function() {
                $('.ui.checkbox', this.$el).checkbox();
            });
        },
        saveMeeting: function(form) {
            if (this.hasReceptionPeriodDetailError(form)) {
                return;
            }
            if (form.model.id) {
                form.put(form.model.edit_api_url, function(response) {
                    this.merge(form.model, response.data);
                    alert('保存しました');
                });
            } else {
                form.post(this.model.new_meeting_api_url, function(response) {
                    this.merge(form.model, response.data);
                    alert('保存しました');
                });
            }
        },
        deleteMeeting: function(form, i) {
            if (!form.model.id) {
                this.meetingForms.splice(i, 1);
                return;
            }
            if (!confirm('削除します。よろしいですか？')) {
                return;
            }
            form.delete(form.model.edit_api_url, function() {
                this.meetingForms.splice(i, 1);
            }.bind(this));
        },
        newLodgeMeeting: function() {
            this.lodgeMeetingForms.push(this.createForm());
            this.$nextTick(function() {
                $('.ui.checkbox', this.$el).checkbox();
            });
        },
        saveLodgeMeeting: function(form) {
            if (form.model.id) {
                form.put(form.model.edit_api_url, function(response) {
                    this.merge(form.model, response.data);
                    alert('保存しました');
                });
            } else {
                form.post(this.model.new_lodge_meeting_api_url, function(response) {
                    this.merge(form.model, response.data);
                    alert('保存しました');
                });
            }
        },
        deleteLodgeMeeting: function(form, i) {
            if (!form.model.id) {
                this.lodgeMeetingForms.splice(i, 1);
                return;
            }
            if (!confirm('削除します。よろしいですか？')) {
                return;
            }
            form.delete(form.model.edit_api_url, function() {
                this.lodgeMeetingForms.splice(i, 1);
            }.bind(this));
        },
        isReceptionPeriodSetting: function(form) {
            var v = form.model.is_all_year;
            return v === false || v === 'false';
        },
        isReceptionDateValueEmpty: function(val) {
            return val == null || (_.isString(val) && _.trim(val) === '');
        },
        receptionStartDateInvalid: function(form) {
            return this.isReceptionPeriodSetting(form) && this.isReceptionDateValueEmpty(form.model.reception_start_date);
        },
        receptionEndDateInvalid: function(form) {
            return this.isReceptionPeriodSetting(form) && this.isReceptionDateValueEmpty(form.model.reception_end_date);
        },
        hasReceptionPeriodDetailError: function(form) {
            return this.receptionStartDateInvalid(form) || this.receptionEndDateInvalid(form);
        },
        openCoursesBulkCopyDialog: function() {
            this.$refs.bulkCopyModal.open(this.model.courses_bulk_copy_api_url, this.groupShops);
        },
        openDrinkMenusBulkCopyDialog: function() {
            this.$refs.bulkCopyModal.open(this.model.drink_menus_bulk_copy_api_url, this.groupShops);
        },
        openMeetingsBulkCopyDialog: function() {
            this.$refs.bulkCopyModal.open(this.model.meetings_bulk_copy_api_url, this.groupShops);
        },
        openLodgeMeetingsBulkCopyDialog: function() {
            this.$refs.bulkCopyModal.open(this.model.lodge_meetings_bulk_copy_api_url, this.groupShops);
        },
        moveUp: function(arr, i) {
            if (i === 0) {
                return;
            }
            var tmp = arr[i - 1];
            this.$set(arr, i-1, arr[i]);
            this.$set(arr, i, tmp);
        },
        moveDown: function(arr, i) {
            if (i === (arr.length - 1)) {
                return;
            }
            var tmp = arr[i + 1];
            this.$set(arr, i+1, arr[i]);
            this.$set(arr, i, tmp);
        },
        reorderCourse: function() {
            this.createForm({
                ids: _.map(this.courseForms, 'model.id')
            }).put(this.model.courses_reorder_api_url, function() {
                this.reload();
            });
        },
        reorderDrinkMenu: function() {
            this.createForm({
                ids: _.map(this.drinkForms, 'model.id')
            }).put(this.model.drinks_reorder_api_url, function() {
                this.reload();
            });
        },
        reorderCatering: function() {
            this.createForm({
                ids: _.map(this.cateringForms, 'model.id')
            }).put(this.model.caterings_reorder_api_url, function() {
                this.reload();
            });
        },
        reorderMeeting: function() {
            this.createForm({
                ids: _.map(this.meetingForms, 'model.id')
            }).put(this.model.meetings_reorder_api_url, function() {
                this.reload();
            });
        },
        reorderLodgeMeeting: function() {
            this.createForm({
                ids: _.map(this.lodgeMeetingForms, 'model.id')
            }).put(this.model.lodge_meetings_reorder_api_url, function() {
                this.reload();
            });
        }
    }
};
</script>

<style scoped>
/*
 * 未入力時は Semantic の .field.error を使わず input のみ着色する。
 * .field.error はラッパーに背景・余白が付き、隣と段差が出るため。
 */
.field.reception-date-missing ::v-deep input.datepick {
    box-sizing: border-box;
    background-color: #fff6f6;
    background-clip: padding-box;
    border: 1px solid #e0b4b4;
}
</style>
